import {
  addMinutes,
  differenceInMinutes,
  isSameDay,
  getHours,
  getMinutes,
} from "date-fns";
import { formatDate, getDateByTimeZone } from "@/lib/date";
import { DELAY_REASONS } from "@/constants";

export const DELIVERY_TYPE_NORMAL = "1";
export const DELIVERY_TYPE_PICKUP = "2";
export const DELIVERY_TYPE_RETURN = "3";

export const DELIVERY_STATUS_0 = "DELIVERY_STATUS_RECEIPT";
export const DELIVERY_STATUS_1 = "DELIVERY_STATUS_PICKUP_SCHEDULED";
export const DELIVERY_STATUS_2 = "DELIVERY_STATUS_PICKUP_COMPLETED";
export const DELIVERY_STATUS_3 = "DELIVERY_STATUS_WAREHOUSED";
export const DELIVERY_STATUS_4 = "DELIVERY_STATUS_DELIVERY_STARTED";
export const DELIVERY_STATUS_5 = "DELIVERY_STATUS_DELIVERED";
export const DELIVERY_STATUS_6 = "DELIVERY_STATUS_DELIVERY_SENT_BACK";
export const DELIVERY_STATUS_7 = "DELIVERY_STATUS_DELIVERY_LOST";
export const DELIVERY_STATUS_8 = "DELIVERY_RIDER_ALLOCATED";
export const DELIVERY_STATUS_9 = "ADDRESS_NOT_SUPPORTED";
export const DELIVERY_STATUS_10 = "ACCIDENT";
export const DELIVERY_STATUS_11 = "CANCELED";
export const DELIVERY_STATUS_12 = "DELIVERY_POSTPONED";
export const DELIVERY_STATUS_14 = "TAKE_OVER";
export const DELIVERY_STATUS_15 = "MAIN_LINE_GET_OFF";
export const DELIVERY_STATUS_16 = "AGENCY_ALLOCATED"; // 배달 대행 관련 (로그에만 사용)
export const DELIVERY_STATUS_17 = "AGENCY_ALLOCATION_FAILED"; // 배달 대행 관련
export const DELIVERY_STATUS_18 = "AGENCY_CANCELED"; // 배달 대행 관련 (로그에만 사용)
export const DELIVERY_STATUS_19 = "AGENCY_DELIVERY_RIDER_ALLOCATED"; // 배달 대행 관련 (로그에만 사용)
export const DELIVERY_STATUS_20 = "AGENCY_DELIVERY_RIDER_ALLOCATION_CANCELED"; // 배달 대행 관련 (로그에만 사용)

export const getPointToArray = (point) => {
  if (point && point.indexOf("POINT") > -1) {
    let pointArray = point.substring(6, point.length - 1).split(" ");

    return pointArray;
  } else {
    return [0, 0];
  }
};

export const renderStatusByNumber = (status) => {
  switch (status) {
    case 0:
      return "접수";
    case 1:
      return "수거지정";
    case 2:
      return "수거완료";
    case 3:
      return "입고완료";
    case 4:
      return "배송출발";
    case 5:
      return "배송완료";
    case 6:
      return "반송완료";
    case 7:
      return "분실완료";
    case 8:
      return "배송배차";
    case 9:
      return "배송불가";
    case 10:
      return "사고";
    case 11:
      return "취소";
    case 12:
      return "배송연기";
    case 14:
      return "배송인수인계";
    case 15:
      return "간선하차";
    case 16:
      return "배달대행 접수";
    case 17:
      return "배달대행 접수 실패";
    case 18:
      return "배달대행에서 취소";
    case 19:
      return "배달대행에서 라이더 배차";
    case 20:
      return "배달대행에서 라이더 배차 취소";
    case 21:
      return "오분류";
    default:
      return "";
  }
};

export class Delivery {
  accidentAt = null;
  accidentReasonOld = "";
  addressNotSupported = false;
  agencyCorpUser = null;
  agencyCorpUserId = null;
  allocationGroupId = null;
  bookId = "";
  bookedAt = null;
  canceledAt = null;
  canceledReasonOld = "";
  corpUser = null;
  deliveryAllocatedDate = null;
  deliveryCompletedDate = null;
  deliveryRider = null;
  deliveryStatusLogs = [];
  delayedDeliveries = [];
  etc1 = "";
  etc2 = "";
  etc3 = "";
  etc4 = "{}";
  manualCompletedDeliveryReason = "";
  notReceivedImageLocationOld = "";
  order = null;
  orderIdFromCorp = "";
  orderIdFromCorpSub = "";
  prepaid = null;
  pickupDateCompleted = null;
  pickupDateScheduled = null;
  pickupRider = null;
  postponedDate = null;
  productCountOld = null;
  productName = "";
  productPrice = 0;
  reallocatedRider = null;
  reallocationRequestedAt = null;
  receiptDate = null;
  receiverAddress = null;
  receiverAddressRoad = null;
  receiverAllocationGroupNameOnWeekdays = null;
  receiverAllocationGroupNameOnWeekends = null;
  receiverDong = null;
  receiverSigungu = null;
  receiverSido = null;
  receiverMobile = "";
  receiverMobile2 = "";
  receiverPoint = null;
  receiverPostalCode = null;
  receiverName = null;
  releasedAt = null;
  requestedDeliveryTime = null;
  senderAllocationGroupNameOnWeekdays = null;
  senderAllocationGroupNameOnWeekends = null;
  senderDong = null;
  senderMobile = "";
  senderMobile2 = "";
  senderName = null;
  senderPostalCode = null;
  senderPoint = null;
  senderAddress = null;
  senderAddressDetail = null;
  senderAddressRoad = null;
  sentBackLogs = null;
  sentBackDate = null;
  signImageLocationOld = "";
  spot = null;
  status = DELIVERY_STATUS_0;
  statusNumber = 0;
  time = null;
  warehousedAt = null;
  type = DELIVERY_TYPE_NORMAL;
  unrefinedAddress = null;
  // canceled
  isAccident = false;
  isCanceled = false;
  _lostDate = null;
  printedObj = {};

  constructor(delivery) {
    this.bookId = delivery.bookId;
    switch (Number(delivery.status)) {
      case 0:
        this.status = DELIVERY_STATUS_0;
        break;
      case 1:
        this.status = DELIVERY_STATUS_1;
        break;
      case 2:
        this.status = DELIVERY_STATUS_2;
        break;
      case 3:
        this.status = DELIVERY_STATUS_3;
        break;
      case 4:
        this.status = DELIVERY_STATUS_4;
        break;
      case 5:
        this.status = DELIVERY_STATUS_5;
        break;
      case 6:
        this.status = DELIVERY_STATUS_6;
        break;
      case 7:
        this.status = DELIVERY_STATUS_7;
        break;
      case 8:
        this.status = DELIVERY_STATUS_8;
        break;
      case 9:
        this.status = DELIVERY_STATUS_9;
        break;
      case 10:
        this.status = DELIVERY_STATUS_10;
        break;
      case 11:
        this.status = DELIVERY_STATUS_11;
        break;
      case 12:
        this.status = DELIVERY_STATUS_12;
        break;
      case 14:
        this.status = DELIVERY_STATUS_14;
        break;
      case 15:
        this.status = DELIVERY_STATUS_15;
        break;
      case 16:
        this.status = DELIVERY_STATUS_16;
        break;
      case 17:
        this.status = DELIVERY_STATUS_17;
        break;
      case 18:
        this.status = DELIVERY_STATUS_18;
        break;
      case 19:
        this.status = DELIVERY_STATUS_19;
        break;
      case 20:
        this.status = DELIVERY_STATUS_20;
        break;
      default:
        this.status = "";
        break;
      // throw new Error("잘못된 배송상태값입니다.");
    }

    this.statusNubmer = delivery.status;

    // dates by status
    this.bookedAt = delivery.bookedAt;
    this.addressNotSupported = delivery.addressNotSupported;
    this.agencyCorpUser = delivery.agencyCorpUser;
    this.agencyCorpUserId =
      delivery.agencyCorpUserId || delivery.agencyCorpUser?.id;
    this.allocationGroupId = delivery.allocationGroupId;
    this.corpUser = delivery.corpUser;
    this.deliveryAllocatedDate = delivery.deliveryAllocatedDate;
    this.deliveryCompletedDate = delivery.deliveryCompletedDate;
    this.deliveryRider = delivery.deliveryRider;
    this.deliveryStatusLogs = delivery.deliveryStatusLogs;
    this.delayedDeliveries = delivery.delayedDeliveries;
    this.etc1 = delivery.etc1;
    this.etc2 = delivery.etc2;
    this.etc3 = delivery.etc3;
    this.etc4 = delivery.etc4;
    this.manualCompletedDeliveryReason = delivery.manualCompletedDeliveryReason;
    this.memoFromCustomer = delivery.memoFromCustomer;
    this.notReceivedImageLocationOld = delivery.notReceivedImageLocation;
    this.order = delivery.order;
    this.orderIdFromCorp = delivery.orderIdFromCorp;
    this.orderIdFromCorpSub = delivery.orderIdFromCorpSub;
    this.postponedDate = delivery.postponedDate;
    this.prepaid = delivery.prepaid;
    this.pickupDateCompleted = delivery.pickupDateCompleted;
    this.pickupRider = delivery.pickupRider;
    this.pickupDateScheduled = delivery.pickupDateScheduled;
    this.printedObj = delivery.printedObj || {};
    this.productCountOld = delivery.productCount || delivery.productCountOld;
    this.reallocationRequestedAt = delivery.reallocationRequestedAt;
    this.reallocatedRider = delivery.reallocatedRider;
    this.receiptDate = delivery.receiptDate;
    this.receiverAddress = delivery.receiverAddress;
    this.receiverAddressRoad = delivery.receiverAddressRoad;
    this.receiverAddressDetail = delivery.receiverAddressDetail;
    this.receiverAllocationGroupNameOnWeekdays =
      delivery.receiverAllocationGroupNameOnWeekdays;
    this.receiverAllocationGroupNameOnWeekends =
      delivery.receiverAllocationGroupNameOnWeekends;
    this.receiverDong = delivery.receiverDongObj;
    this.receiverMobile = delivery.receiverMobile;
    this.receiverMobile2 = delivery.receiverMobile2;
    this.receiverName = delivery.receiverName;
    this.receiverPoint = delivery.receiverPoint;
    this.receiverPostalCode = delivery.receiverPostalCode;
    this.receiverSigungu =
      (delivery.receiverDongObj && delivery.receiverDongObj.sigungu) || null;
    this.receiverSido =
      (this.receiverSigungu && this.receiverSigungu.sido) || null;
    this.releasedAt = delivery.releasedAt;
    this.requestedDeliveryTime = delivery.requestedDeliveryTime;
    this.productPrice = delivery.productPrice;
    this.productName = delivery.productName;
    this.senderAddress = delivery.senderAddress;
    this.senderAddressDetail = delivery.senderAddressDetail;
    this.senderAddressRoad = delivery.senderAddressRoad;
    this.senderAllocationGroupNameOnWeekdays =
      delivery.senderAllocationGroupNameOnWeekdays;
    this.senderAllocationGroupNameOnWeekends =
      delivery.senderAllocationGroupNameOnWeekends;
    this.senderDong = delivery.senderDongObj;
    this.senderMobile = delivery.senderMobile;
    this.senderMobile2 = delivery.senderMobile2;
    this.senderName = delivery.senderName;
    this.senderPostalCode = delivery.senderPostalCode;
    this.senderPoint = delivery.senderPoint;
    this.signImageLocationOld = delivery.signImageLocation;
    this.sentBackLogs = delivery.sentBackLogs;
    this.sentBackDate = delivery.sentBackDate;
    this.spot = delivery.spot || null;
    this.time = delivery.time || null;
    this.type = delivery.type || DELIVERY_TYPE_NORMAL;
    this.warehousedAt = delivery.warehousedAt;

    // canceled
    this.isAccident = !!delivery.isAccident;
    this.accidentAt = delivery.accidentAt || null;
    this.accidentReasonOld = delivery.accidentReason || null;
    this.isCanceled = !!delivery.isCanceled;
    this.canceledAt = delivery.canceledAt || null;
    this.canceledReasonOld = delivery.canceledReason || null;

    this.unrefinedAddress = delivery.unrefinedAddress;

    this._lostDate = delivery._lostDate;
  }

  get addressApiType() {
    return this.etc4Obj ? this.etc4Obj.addressApiType : "";
  }

  get accidentReason() {
    return this.etc4Obj?.accidentReason || this.accidentReasonOld;
  }

  get agencyNotReceivedImageLocation() {
    return this.etc4Obj ? this.etc4Obj.agencyNotReceivedImageLocation : "";
  }

  get agencyDeliveryRiderName() {
    return this.etc4Obj ? this.etc4Obj.agencyDeliveryRiderName : "";
  }

  get agencyDeliveryRiderMobile() {
    return this.etc4Obj ? this.etc4Obj.agencyDeliveryRiderMobile : "";
  }

  get agencyOrderId() {
    return this.etc4Obj ? this.etc4Obj.agencyOrderId : "";
  }

  get canceledReason() {
    return this.etc4Obj?.canceledReason || this.canceledReasonOld;
  }

  get cjOrderIdFromCorpFromOliveyoung() {
    return this.etc4Obj?.cjOrderIdFromCorpFromOliveyoung;
  }

  get completedLocation() {
    return this.etc4Obj ? this.etc4Obj.completedLocation : "";
  }

  get corpUserCorpTitle() {
    return this.corpUser ? this.corpUser.corpTitle : "";
  }

  get corpUserContact() {
    return this.corpUser ? this.corpUser.contact : "";
  }

  get corpUserRealname() {
    return this.corpUser ? this.corpUser.realname : "";
  }

  get customerAddress() {
    return this.etc4Obj ? this.etc4Obj.customerAddress : "";
  }

  get customerAddressEng() {
    return this.etc4Obj ? this.etc4Obj.customerAddressEng : "";
  }

  get customerAddressEngGpt() {
    return this.etc4Obj ? this.etc4Obj.customerAddressEngGpt : "";
  }

  get customerAddressDetail() {
    return this.etc4Obj ? this.etc4Obj.customerAddressDetail : "";
  }

  get customerAddressPostalCode() {
    return this.etc4Obj ? this.etc4Obj.customerAddressPostalCode : "";
  }

  get delayReasonCode() {
    return this.etc4Obj ? this.etc4Obj.delayReasonCode : "";
  }

  get deliveryDoneLatitude() {
    return this.etc4Obj ? this.etc4Obj.deliveryDoneLatitude : "";
  }

  get deliveryDoneLongitude() {
    return this.etc4Obj ? this.etc4Obj.deliveryDoneLongitude : "";
  }

  get deliveryLostLatitude() {
    return this.etc4Obj ? this.etc4Obj.deliveryLostLatitude : "";
  }

  get deliveryLostLongitude() {
    return this.etc4Obj ? this.etc4Obj.deliveryLostLongitude : "";
  }

  get deliveryPlace() {
    return this.etc4Obj ? this.etc4Obj.deliveryPlace : "";
  }

  get deliveryPlacedTime() {
    return this.etc4Obj ? this.etc4Obj.deliveryPlacedTime : "";
  }

  get deliveryRiderName() {
    return this.deliveryRider ? this.deliveryRider.name : "";
  }

  get deliverySentBackLatitude() {
    return this.etc4Obj ? this.etc4Obj.deliverySentBackLatitude : "";
  }

  get deliverySentBackLongitude() {
    return this.etc4Obj ? this.etc4Obj.deliverySentBackLongitude : "";
  }

  get etc4Obj() {
    try {
      return this.etc4 && JSON.parse(this.etc4);
    } catch (e) {
      return {};
    }
  }

  get frontdoorPassword() {
    if (this.frontdoorPasswordByClient) {
      return `${this.frontdoorPasswordByClient} ${
        this.frontdoorPasswordByCorp ? `/ ${this.frontdoorPasswordByCorp}` : ""
      }`;
    } else {
      return this.frontdoorPasswordByCorp || null;
    }
  }

  get frontdoorPasswordByClient() {
    return this.etc4Obj ? this.etc4Obj.frontdoorPasswordByClient : "";
  }

  get frontdoorPasswordByCorp() {
    return this.etc4Obj ? this.etc4Obj.frontdoorPasswordByCorp : "";
  }

  get gatheredDeliveries() {
    return this.etc4Obj?.gatheredDeliveries || [];
  }

  get lostBreakageImageLocation() {
    return this.etc4Obj?.lostBreakageImageLocation || "";
  }

  get lostBreakageImageLocations() {
    return this.lostBreakageImageLocation
      ? [this.lostBreakageImageLocation]
      : [];
  }

  get lostReason() {
    return this.etc4Obj && this.etc4Obj.lostReason
      ? this.etc4Obj.lostReason
      : "";
  }

  get misclassifiedAt() {
    return this.etc4Obj?.misclassifiedAt;
  }

  get notReceivedImageLocation() {
    return this.etc4Obj && this.etc4Obj.notReceivedImageLocation
      ? this.etc4Obj.notReceivedImageLocation
      : this.notReceivedImageLocationOld;
  }

  get notReceivedImageLocations() {
    if (this.etc4Obj?.notReceivedImageLocations) {
      return this.etc4Obj?.notReceivedImageLocations;
    } else if (this.notReceivedImageLocation) {
      return [this.notReceivedImageLocation];
    } else {
      return [];
    }
  }

  get orderingNumberByDeliveryRiderId() {
    return this.etc4Obj?.orderingNumberByDeliveryRiderId || "";
  }

  get pickupRiderName() {
    return this.pickupRider ? this.pickupRider.name : "";
  }

  // 수거완료 위치
  get pickedupLatitude() {
    return this.etc4Obj ? this.etc4Obj.pickedupLatitude : "";
  }

  // 수거완료 위치
  get pickedupLongitude() {
    return this.etc4Obj ? this.etc4Obj.pickedupLongitude : "";
  }

  get pickupCompletedImage() {
    if (this.etc4Obj?.pickupCompletedImage) {
      if (
        this.etc4Obj?.pickupCompletedImage.indexOf(
          "https://noritake-delivery-images-dev.s3.ap-northeast-2.amazonaws.com",
        ) > -1 &&
        this.pickupDateCompleted &&
        new Date(this.pickupDateCompleted) < new Date("2025-05-19 00:00:00")
      ) {
        return this.etc4Obj?.pickupCompletedImage.replace(
          "https://noritake-delivery-images-dev.s3.ap-northeast-2.amazonaws.com",
          "https://storage.googleapis.com/doobal-files-dev",
        );
      } else if (
        this.etc4Obj?.pickupCompletedImage.indexOf(
          "https://noritake-delivery-images.s3.ap-northeast-2.amazonaws.com",
        ) > -1 &&
        this.pickupDateCompleted &&
        new Date(this.pickupDateCompleted) < new Date("2025-05-19 00:00:00")
      ) {
        return this.etc4Obj?.pickupCompletedImage.replace(
          "https://noritake-delivery-images.s3.ap-northeast-2.amazonaws.com",
          "https://storage.googleapis.com/doobal-files",
        );
      } else {
        return this.etc4Obj?.pickupCompletedImage;
      }
    } else {
      return null;
    }
  }

  // 수거취소 위치
  get pickupCanceledLatitude() {
    return this.etc4Obj ? this.etc4Obj.pickupCanceledLatitude : "";
  }

  // 수거취소 위치
  get pickupCanceledLongitude() {
    return this.etc4Obj ? this.etc4Obj.pickupCanceledLongitude : "";
  }

  // 수거취소 이미지
  get pickupCanceledImage() {
    return this.etc4Obj ? this.etc4Obj.pickupCanceledImage : "";
  }

  get reallocatedRiderName() {
    return this.reallocatedRider ? this.reallocatedRider.name : "";
  }

  get prepaidText() {
    return this.prepaid ? "선불" : "후불";
  }

  get printedOnAdmin() {
    return this.printedObj?.onAdmin || false;
  }

  get printedOnSubAdmin() {
    return this.printedObj?.onSubAdmin || false;
  }

  get productCount() {
    return this.etc4Obj?.productCount || this.productCountOld;
  }

  get receiverAddressObj() {
    return this.etc4Obj ? this.etc4Obj.receiverAddressObj : null;
  }

  get receiverAddressPostalCode() {
    return this.receiverAddressObj ? this.receiverAddressObj.postalCode : null;
  }

  get receiverAddressRoadWithoutSigungu() {
    if (this.receiverAddressRoad) {
      let receiverAddressRoadArr = this.receiverAddressRoad.split(" ");

      if (receiverAddressRoadArr.length > 2) {
        return receiverAddressRoadArr
          .slice(2, receiverAddressRoadArr.length)
          .join(" ");
      } else {
        return this.receiverAddressRoad;
      }
    } else {
      return "";
    }
  }

  get receiverAddressUpdatedBy() {
    if (this.etc4Obj?.receiverAddressUpdatedBy) {
      switch (this.etc4Obj?.receiverAddressUpdatedBy) {
        case "rider":
          return "라이더";
        case "admin":
          return "관리자";
        default:
          return "";
      }
    } else {
      return "";
    }
  }

  get receiverAddressUpdatedByName() {
    return this.etc4Obj?.receiverAddressUpdatedByName || "";
  }

  get receiverAddressUpdatedAt() {
    return this.etc4Obj?.receiverAddressUpdatedAt || "";
  }

  get receiverBuildingDongNumber() {
    if (this.receiverAddressObj && this.receiverAddressObj.buildingDongNumber) {
      return this.receiverAddressObj.buildingDongNumber;
    } else {
      return null;
    }
  }

  get receiverDongName() {
    return this.receiverDong ? this.receiverDong.name : "";
  }

  get receiverSigunguName() {
    return this.receiverSigungu ? this.receiverSigungu.name : "";
  }

  get receiverSidoName() {
    return this.receiverSido ? this.receiverSido.name : "";
  }

  get receiverLnglat() {
    return {
      longitude: getPointToArray(this.receiverPoint)[0],
      latitude: getPointToArray(this.receiverPoint)[1],
    };
  }

  get renderAddressApiType() {
    if (this.addressApiType === "SOOJIONE") {
      if (this.soojioneLimitedCustomized) {
        return "입력 주소값 일치 정제";
      } else {
        return "건물명 매칭 조정정제";
      }
    } else if (this.addressApiType === "SOOJIONE_PROHIBITED") {
      return "입력 주소값 일치 정제";
    } else if (this.addressApiType === "SOOJIONE_NOT_PROHIBITED") {
      return "건물명 매칭 조정정제";
    } else if (this.addressApiType === "TMAP") {
      return "서브1 정제:기본정제실패";
    } else if (this.addressApiType === "KAKAO") {
      return "서브2 정제:기본정제실패";
    } else {
      return "";
    }
  }

  renderDelayReasonCode() {
    return this.delayReasonCode
      ? DELAY_REASONS.find(
          (e) =>
            e.code ===
            (this.delayReasonCode.includes("DELIVERY_POSTPONED_")
              ? this.delayReasonCode.split("DELIVERY_POSTPONED_")[1]
              : this.delayReasonCode),
        )?.text
      : "";
  }

  get renderManualCompletedDeliveryReason() {
    return (
      this.etc4Obj?.manualCompletedDeliveryReason ||
      this.manualCompletedDeliveryReason
    );
  }

  get sendedCompletedSms() {
    return this.etc4Obj ? this.etc4Obj.sendedCompletedSms : false;
  }

  get senderAddressObj() {
    if (this.etc4Obj && this.etc4Obj.senderAddressObj) {
      if (typeof this.etc4Obj.senderAddressObj === "string") {
        return JSON.parse(this.etc4Obj.senderAddressObj);
      } else if (typeof this.etc4Obj.senderAddressObj === "object") {
        return this.etc4Obj.senderAddressObj;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  get senderAddressUpdatedBy() {
    if (this.etc4Obj?.senderAddressUpdatedBy) {
      switch (this.etc4Obj?.senderAddressUpdatedBy) {
        case "rider":
          return "라이더";
        case "admin":
          return "관리자";
        default:
          return "";
      }
    } else {
      return "";
    }
  }

  get senderAddressUpdatedByName() {
    return this.etc4Obj?.senderAddressUpdatedByName || "";
  }

  get senderAddressUpdatedAt() {
    return this.etc4Obj?.senderAddressUpdatedAt || "";
  }

  get senderBuildingDongNumber() {
    if (this.senderAddressObj && this.senderAddressObj.buildingDongNumber) {
      return this.senderAddressObj.buildingDongNumber;
    } else {
      return null;
    }
  }

  get senderAddressPostalCode() {
    return this.senderAddressObj ? this.senderAddressObj.postalCode : "";
  }

  get senderDongName() {
    return this.senderDong && this.senderDong.name;
  }

  get senderLnglat() {
    return {
      longitude: getPointToArray(this.senderPoint)[0],
      latitude: getPointToArray(this.senderPoint)[1],
    };
  }

  get sentBackReason() {
    return this.sentBackLogs && this.sentBackLogs.length > 0
      ? this.sentBackLogs[0].reason
      : "";
  }

  get signImageLocation() {
    return this.etc4Obj && this.etc4Obj.signImageLocation
      ? this.etc4Obj.signImageLocation
      : this.signImageLocationOld;
  }

  get signImageLocations() {
    if (this.etc4Obj?.signImageLocations) {
      return this.etc4Obj?.signImageLocations;
    } else if (this.signImageLocation) {
      return [this.signImageLocation];
    } else {
      return [];
    }
  }

  get soojioneLimitedCustomized() {
    return (
      this.etc4Obj?.alteredAddressForSoojione ||
      this.etc4Obj?.soojioneLimitedCustomized
    );
  }

  get soojioneLimitedCustomizedLngLat() {
    return {
      longitude: getPointToArray(this.soojioneLimitedCustomized?.point)[0],
      latitude: getPointToArray(this.soojioneLimitedCustomized?.point)[1],
    };
  }

  get spotName() {
    return this.spot && this.spot.name;
  }

  get totalProductName() {
    let productNames = [];

    if (this.productName) {
      let _productName = `${this.productName}${
        this.productCount ? ` [${this.productCount}개]` : ""
      }`;
      productNames.push(_productName);
    }

    if (this.gatheredDeliveries.length > 0) {
      this.gatheredDeliveries.forEach((delivery) => {
        let _productName = `${delivery.productName}${
          delivery.productCount ? ` [${delivery.productCount}개]` : ""
        }`;
        productNames.push(_productName);
      });
    }

    return productNames.join(";;");
  }

  get totalQuantity() {
    let quantity = 0;

    if (this.productCount) {
      quantity += Number(this.productCount);
    }

    if (this.gatheredDeliveries.length > 0) {
      this.gatheredDeliveries.forEach((d) => {
        quantity += Number(d.productCount);
      });
    }

    return quantity;
  }

  get isPossibleToRestoreAccident() {
    return !!this.isAccident;
  }

  get isPossibleToRestoreCancel() {
    return !!this.isCanceled;
  }

  get isPossibleToKookmin() {
    return (
      !this.isAccident &&
      !this.isCanceled &&
      this.status === DELIVERY_STATUS_4 &&
      this.type === DELIVERY_TYPE_NORMAL
    );
  }

  get isPossibleToCancelKookmin() {
    return !!this.agencyCorpUserId && this.status !== DELIVERY_STATUS_17;
  }

  get isPossibleToSetDeliveryCompletedStatus() {
    return (
      !this.isAccident && !this.isCanceled && this.status === DELIVERY_STATUS_4
    );
  }

  get isPossibleToSetPreviousStatus() {
    return !this.isAccident && !this.isCanceled;
  }

  get isPossibleToSetDeliveryStarted() {
    return (
      !this.isAccident &&
      !this.isCanceled &&
      (this.status === DELIVERY_STATUS_3 ||
        this.status === DELIVERY_STATUS_8 ||
        this.status === DELIVERY_STATUS_17) &&
      this.deliveryRider &&
      !this.reallocatedRider
    );
  }

  get isPossibleToSetWarehousedStatus() {
    return (
      !this.isAccident && !this.isCanceled && this.status === DELIVERY_STATUS_2
    );
  }

  get isPossibleToSetWarehousedStatusBeforePickup() {
    return (
      !this.isAccident && !this.isCanceled && this.status === DELIVERY_STATUS_1
    );
  }

  get isPossibleToUpdateKookmin() {
    return !!this.agencyCorpUserId;
  }

  get updateDeliveryCompletedStateByAdmin() {
    return this.etc4Obj && this.etc4Obj.updateDeliveryCompletedStateByAdmin;
  }

  get updateDeliveryCompletedStateBy() {
    return this.etc4Obj && this.etc4Obj.updateDeliveryCompletedStateBy;
  }

  get updateDeliveryCompletedStateAt() {
    return this.etc4Obj && this.etc4Obj.updateDeliveryCompletedStateAt;
  }

  renderAccidentAt(dateFormat = "MM/dd HH:mm") {
    return (
      this.accidentAt &&
      formatDate(getDateByTimeZone(this.accidentAt), dateFormat)
    );
  }

  renderBookId() {
    if (this.status === DELIVERY_STATUS_17) {
      return `(실)${this.bookId}`;
    } else if (this.agencyCorpUserId) {
      return `(배)${this.bookId}`;
    } else if (this.status === DELIVERY_STATUS_7) {
      return `(분)${this.bookId}`;
    } else if (this.status === DELIVERY_STATUS_6) {
      return `(반)${this.bookId}`;
    } else if (this.type === DELIVERY_TYPE_PICKUP) {
      return `(픽)${this.bookId}`;
    } else {
      return this.bookId;
    }
  }

  renderCanceledAt(dateFormat = "MM/dd HH:mm") {
    return (
      this.canceledAt &&
      formatDate(getDateByTimeZone(this.canceledAt), dateFormat)
    );
  }

  renderDeliveryCompletedDate(dateFormat = "MM/dd HH:mm") {
    let suffix = "";

    if (this.status === DELIVERY_STATUS_7) {
      suffix = "(분)";
    } else if (this.status === DELIVERY_STATUS_6) {
      suffix = "(반)";
    }

    if (this.deliveryCompletedDate) {
      return `${formatDate(
        getDateByTimeZone(this.deliveryCompletedDate),
        dateFormat,
      )}${suffix}`;
    } else {
      return "";
    }
  }

  // renderDeliveryLostDate(dateFormat = "MM/dd HH:mm") {
  //   return (
  //     this.renderDeliveryStatusLogsCreatedAt(7) &&
  //     formatDate(
  //       getDateByTimeZone(this.renderDeliveryStatusLogsCreatedAt(7)),
  //       dateFormat,
  //     )
  //   );

  renderLostDate(dateFormat = "MM/dd HH:mm") {
    return (
      this.status === DELIVERY_STATUS_7 &&
      this.deliveryCompletedDate &&
      formatDate(getDateByTimeZone(this.deliveryCompletedDate), dateFormat)
    );
  }

  // renderDeliverySentBackDate(dateFormat = "MM/dd HH:mm") {
  //   return (
  //     this.renderDeliveryStatusLogsCreatedAt(6) &&
  //     formatDate(
  //       getDateByTimeZone(this.renderDeliveryStatusLogsCreatedAt(6)),
  //       dateFormat,
  //     )
  //   );
  // }

  // renderDeliveryStatusLogsCreatedAt(after = 7) {
  //   const deliveryStatusLog =
  //     this.deliveryStatusLogs &&
  //     this.deliveryStatusLogs.find((el) => el.after === after);

  //   if (deliveryStatusLog) {
  //     return deliveryStatusLog.createdAt;
  //   } else {
  //     return null;
  //   }
  // }

  renderLatestDate() {
    if (this.addressNotSupported) {
      return "";
    } else {
      switch (this.status) {
        case DELIVERY_STATUS_0:
          return this.renderReceiptDate();
        case DELIVERY_STATUS_1:
          return this.renderPickupDateScheduled("HH:mm");
        case DELIVERY_STATUS_2:
          return this.renderPickupDateCompleted("HH:mm");
        case DELIVERY_STATUS_3:
          return this.renderWarehousedAt("HH:mm");
        case DELIVERY_STATUS_4:
          return this.renderReleasedAt();
        case DELIVERY_STATUS_5:
        case DELIVERY_STATUS_6:
        case DELIVERY_STATUS_7:
          return this.renderDeliveryCompletedDate();
        case DELIVERY_STATUS_8:
          return this.renderDeliveryAllocatedDate();
        case DELIVERY_STATUS_9:
        case DELIVERY_STATUS_10:
        case DELIVERY_STATUS_11:
          return "";
        case DELIVERY_STATUS_12:
          return this.renderPostponedDate();
        case DELIVERY_STATUS_14:
        case DELIVERY_STATUS_15:
        case DELIVERY_STATUS_16:
        case DELIVERY_STATUS_17:
        case DELIVERY_STATUS_18:
        case DELIVERY_STATUS_19:
        case DELIVERY_STATUS_20:
          return "";
        default:
          return "";
      }
    }
  }
  renderPickupDateCompleted(dateFormat = "MM/dd HH:mm") {
    return (
      this.pickupDateCompleted &&
      formatDate(getDateByTimeZone(this.pickupDateCompleted), dateFormat)
    );
  }

  renderPickupDateScheduled(dateFormat = "MM/dd HH:mm") {
    return (
      this.pickupDateScheduled &&
      formatDate(getDateByTimeZone(this.pickupDateScheduled), dateFormat)
    );
  }

  renderReallocationRequestedAt(dateFormat = "MM/dd HH:mm") {
    return (
      this.reallocationRequestedAt &&
      formatDate(getDateByTimeZone(this.reallocationRequestedAt), dateFormat)
    );
  }

  renderReceiptDate(dateFormat = "MM/dd HH:mm") {
    return (
      this.receiptDate &&
      formatDate(getDateByTimeZone(this.receiptDate), dateFormat)
    );
  }

  renderReceiverAddressUpdatedAt(dateFormat = "yyyy-MM-dd HH:mm") {
    return (
      this.receiverAddressUpdatedAt &&
      formatDate(getDateByTimeZone(this.receiverAddressUpdatedAt), dateFormat)
    );
  }

  renderDeliveryAllocatedDate(dateFormat = "MM/dd HH:mm") {
    return (
      this.deliveryAllocatedDate &&
      formatDate(getDateByTimeZone(this.deliveryAllocatedDate), dateFormat)
    );
  }

  renderRequestedDeliveryTime(dateFormat = "yyyy-MM-dd HH:mm") {
    return (
      this.requestedDeliveryTime &&
      formatDate(getDateByTimeZone(this.requestedDeliveryTime), dateFormat)
    );
  }

  renderPostponedDate(dateFormat = "MM/dd HH:mm") {
    return (
      this.postponedDate &&
      formatDate(getDateByTimeZone(this.postponedDate), dateFormat)
    );
  }

  renderReleasedAt(dateFormat = "MM/dd HH:mm") {
    return (
      this.releasedAt &&
      formatDate(getDateByTimeZone(this.releasedAt), dateFormat)
    );
  }

  renderSenderAddressUpdatedAt(dateFormat = "yyyy-MM-dd HH:mm") {
    return (
      this.senderAddressUpdatedAt &&
      formatDate(getDateByTimeZone(this.senderAddressUpdatedAt), dateFormat)
    );
  }

  renderSentBackDate(dateFormat = "MM/dd HH:mm") {
    return (
      this.status === DELIVERY_STATUS_6 &&
      this.deliveryCompletedDate &&
      formatDate(getDateByTimeZone(this.deliveryCompletedDate), dateFormat)
    );
  }
  renderEstimatedTime() {
    if (this.status === DELIVERY_STATUS_4 && this.order) {
      const current = new Date();

      const from = addMinutes(new Date(), this.order * 10);
      const to = addMinutes(new Date(), this.order * 10 + 120);

      let displayFrom = formatDate(from, "H:m");
      if (
        !isSameDay(current, from) ||
        (getHours(from) >= 22 && getMinutes(from) >= 30)
      ) {
        displayFrom = "22:30";
      }

      let displayTo = formatDate(to, "H:m");
      if (
        !isSameDay(current, to) ||
        (getHours(to) >= 22 && getMinutes(to) >= 30)
      ) {
        displayTo = "22:30";
      }

      return `${displayFrom} ~ ${displayTo}(${this.order})`;
    } else {
      return "";
    }
  }

  renderStatus() {
    if (this.addressNotSupported) {
      return "배송불가";
    } else {
      switch (this.status) {
        case DELIVERY_STATUS_1:
          return "수거지정";
        case DELIVERY_STATUS_2:
          return "수거완료";
        case DELIVERY_STATUS_3:
          return "입고완료";
        case DELIVERY_STATUS_4:
          return "배송출발";
        case DELIVERY_STATUS_5:
          return "배송완료";
        case DELIVERY_STATUS_6:
          return "반송완료";
        case DELIVERY_STATUS_7:
          return "분실완료";
        case DELIVERY_STATUS_8:
          return "배송배차";
        case DELIVERY_STATUS_9:
          return "배송불가";
        case DELIVERY_STATUS_10:
          return "사고";
        case DELIVERY_STATUS_11:
          return "취소";
        case DELIVERY_STATUS_12:
          return "배송연기";
        case DELIVERY_STATUS_14:
          return "배송인수인계";
        case DELIVERY_STATUS_15:
          return "간선하차";
        case DELIVERY_STATUS_16:
          return "배달대행 접수";
        case DELIVERY_STATUS_17:
          return "배달대행 접수 실패";
        case DELIVERY_STATUS_18:
          return "배달대행에서 취소";
        case DELIVERY_STATUS_19:
          return "배달대행에서 라이더 배차";
        case DELIVERY_STATUS_20:
          return "배달대행에서 라이더 배차 취소";
        default:
          return "접수";
      }
    }
  }

  renderTime() {
    let total = 0;

    if (this.releasedAt && this.deliveryCompletedDate) {
      total = differenceInMinutes(
        new Date(this.deliveryCompletedDate),
        new Date(this.releasedAt),
      );
    } else {
      return "";
    }

    const time = parseInt(total / 60);
    const minute = total % 60;

    return `${time < 10 ? "0" : ""}${time}:${minute < 10 ? "0" : ""}${minute}`;
  }

  renderWarehousedAt(dateFormat = "MM/dd HH:mm") {
    return (
      this.warehousedAt &&
      formatDate(getDateByTimeZone(this.warehousedAt), dateFormat)
    );
  }
}
